var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.1 1 1 4.1 1 8C1 11.9 4.1 15 8 15C11.9 15 15 11.9 15 8C15 4.1 11.9 1 8 1ZM5 13.2V11.7C5 10.8 5.6 10.1 6.5 10H9.5C10.4 10.1 11 10.8 11 11.7V13.2C9.1 14.3 6.9 14.3 5 13.2ZM12 12V11.2C12 10.3 10.9 9.1 9.5 9H6.5C5.1 9.1 4 10.3 4 11.7V12.2V12.5C1.5 10.3 1.3 6.5 3.5 4C5.7 1.5 9.5 1.3 12 3.5C14.5 5.7 14.7 9.5 12.5 12C12.4 12.2 12.2 12.3 12 12.5V12Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C6.6 3 5.5 4.1 5.5 5.5C5.5 6.9 6.6 8 8 8C9.4 8 10.5 6.9 10.5 5.5C10.5 4.1 9.4 3 8 3ZM8 7C7.2 7 6.5 6.3 6.5 5.5C6.5 4.7 7.2 4 8 4C8.8 4 9.5 4.7 9.5 5.5C9.5 6.3 8.8 7 8 7Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAvatar);
export default __webpack_public_path__ + "static/media/emptyAvatar.18dd674fe4672309a42a57402f17a105.svg";
export { ForwardRef as ReactComponent };